import { z } from 'zod'

import { listQueryZodFields } from './system'
import { dbEntitySchema } from './system'
import { micrositeSingleValueMetaTags } from '../constants/microsite'

// Meta tag schema with validation for unique tags
export const metaTagSchema = z.object({
  key: z.string().min(1),
  value: z.string(),
})

// Global template schema (header/footer)
export const globalTemplateSchema = z.object({
  mdxContent: z.string().optional(), // For MDX templates
  mdxArtifactUrl: z.string().optional(), // Compiled MDX artifact
})

export const micrositeSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string(),
  name: z.string().min(1).max(200),
  slug: z
    .string()
    .min(1)
    .max(100)
    .regex(/^[a-z0-9-]+$/),
  description: z.string().max(1000).optional(),
  metaTags: z
    .array(metaTagSchema)
    .optional()
    .refine(
      (tags) => {
        if (!tags) return true
        const keys = tags.map((tag) => tag.key.toLowerCase())
        const singleValueTags = keys.filter((key) =>
          micrositeSingleValueMetaTags.includes(key as any)
        )
        return singleValueTags.length === new Set(singleValueTags).size
      },
      {
        message: `Meta tags like ${micrositeSingleValueMetaTags.join(', ')} can only appear once`,
      }
    ),
  globalHeader: globalTemplateSchema.optional(),
  globalFooter: globalTemplateSchema.optional(),
  published: z.boolean().default(false),
  customDomain: z.string().optional(),
})

export const micrositeListArgsSchema = z.object({
  ...listQueryZodFields,
  organizationId: z.string().optional(),
  venueId: z.string().optional(),
  published: z.boolean().optional(),
})

export const micrositeCreateArgsSchema = micrositeSchema
  .omit({
    _id: true,
    id: true,
    deleted: true,
    organization: true,
    venue: true,
    created: true,
    modified: true,
  })
  .extend({
    venueId: z.string(),
  })

export const micrositeUpdateByIdArgsSchema = micrositeSchema
  .omit({
    _id: true,
    id: true,
    organization: true,
    venue: true,
    created: true,
    modified: true,
    deleted: true,
  })
  .partial()

// Responses
export const micrositeListResponseSchema = z.object({
  data: z.array(micrositeSchema),
})
